var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "ManageCreditCardModal" + _vm.apparatusId,
        size: "lg",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "no-fade": "",
        "no-stacking": "",
        centered: ""
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function() {
            return [
              _c("div", { staticClass: "pt-3" }, [
                _c(
                  "h2",
                  {
                    staticClass: "font-weight-normal",
                    attrs: {
                      "data-test-hook":
                        "mobile-subscription-manage-credit-card-modal-header"
                    }
                  },
                  [
                    _c("div", [
                      _c("i", {
                        staticClass:
                          "far fa-exclamation-triangle colorOrange mr-1",
                        attrs: {
                          "data-test-hook":
                            "mobile-subscription-manage-credit-card-modal-header-icon"
                        }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("xYourAccountNeedsAttentionHeader")) +
                          " "
                      )
                    ])
                  ]
                )
              ]),
              _c(
                "div",
                { staticClass: "float-right" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn-icon-button--gray",
                      attrs: {
                        variant: "icon-button",
                        "data-test-hook": "x-button-feedback-modal"
                      },
                      on: {
                        click: function($event) {
                          return _vm.closeModal()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-times" })]
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        },
        {
          key: "modal-footer",
          fn: function() {
            return [
              !_vm.isYellowstone
                ? _c(
                    "b-button",
                    {
                      attrs: { variant: "secondary" },
                      on: {
                        click: function($event) {
                          return _vm.$router.push({
                            path: `/details/${_vm.apparatusId}/deviceDetails`
                          })
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.viewDetailsButtonLabel) + " ")]
                  )
                : _vm._e(),
              _vm.isWebSubscription
                ? _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        disabled: _vm.billingMaintenanceFeatureFlagEnabled(
                          _vm.currentAppConfig
                        )
                      },
                      on: {
                        click: function($event) {
                          return _vm.goToUpgradeModal()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("xUpdatePaymentMethod")) + " ")]
                  )
                : _vm._e()
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", [
        _c("p", [
          _vm._v(
            " " +
              _vm._s(_vm.$t("xUpdateYourPaymentMethodGeneral")) +
              " " +
              _vm._s(_vm.getModalTextDate()) +
              " " +
              _vm._s(_vm.$t("xYourPlanWillBeCanceled")) +
              " "
          )
        ]),
        _c("p", [_vm._v(_vm._s(_vm.getModalBodyText()))])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }